export enum FeatureFlagKey {
  LimitFreeTierActiveWebhooks = "limit-free-tier-active-webhooks",
  NewDowngradeFlow = "new-downgrade-flow",
  BrevoUsageLimitEmail = "brevo-usage-limit-email",
  BaseGoerliDeprecation = "base-goerli-deprecation",
  ReduceMultiplexing = "reduce-multiplexing",
  zkSync = "zksync",
  BNBMainnet = "bnb-mainnet",
  BNBTestnet = "bnb-testnet",
  NewUsageCharts = "new-usage-charts",
  HomePageProductRecommendation = "homepage-product-recommendation",
}

export enum ReduceMultiplexingVariant {
  NeitherPhoneNumberOrFreeTierCreditCardRequired = "NEITHER_PHONE_NUMBER_OR_FREE_TIER_CREDIT_CARD_REQUIRED",
  OnlyPhoneNumberRequired = "ONLY_PHONE_NUMBER_REQUIRED",
  OnlyFreeTierCreditCardRequired = "ONLY_FREE_TIER_CREDIT_CARD_REQUIRED",
  PhoneNumberAndFreeTierCreditCardRequired = "PHONE_NUMBER_AND_FREE_TIER_CREDIT_CARD_REQUIRED",
}
